;(function(){

	var $pb = $('#proper-brew');

	if( $pb.length <= 0 ) return false;

	$pb = {
		root: $pb,
		wrapper: $pb.find('.proper-brew__wrapper'),
		slides: $pb.find('.proper-brew__slide'),
		// navigation: $pb.find('#proper-brew__navigation'),
		arrows: $pb.find('#proper-brew__arrows'),
		current: false
	};

	var pb = {
		current: $pb.slides.filter('.proper-brew__slide--active').index(),
		busy: 0,
		total: $pb.slides.length,
		init: function(){

			// Store the slides
			$pb.slides
				.each(function(i){

					var $s = $(this);

					$pb.slides[i] = {
						root: $s,
						image: $s.find('.proper-brew__slide-img'),
						copy: $s.find('.proper-brew__slide-copy')
					};

				});

			// Get the current
			$pb.current = $pb.slides[pb.current];

			/*// Set nav
			$pb.navigation
				.find('li:eq(' + pb.current + ')')
				.addClass('active');*/

			// Activate the arrows
			$pb.arrows
				.on('click', 'a', function(e){

					var next = $(this).is('.next'),
						newP = next ? pb.current + 1 : pb.current - 1;

					if( newP < 0 ){
						newP = pb.total - 1;
					}else if( newP > pb.total - 1 ){
						newP = 0;
					}

					pb.goTo(newP, next ? 'left' : 'right');

					e.preventDefault();

				});

			/*// Activate the navigation
			$pb.navigation
				.on('click', 'a', function(e){

					var newP = $(this).parent().index();

					pb.goTo(newP, newP > pb.current ? 'left' : 'right');

					e.preventDefault();

				});*/

			$pb.wrapper.on('touchstart', pb.touch);

		},
		goTo: function(num, dir, skipExit) {

			// Ignore if already active
			if( num == pb.current || pb.busy ) return;

			// Busy now
			pb.busy = true;

			// Scroll to top
			/*TweenLite
				.to(window, .5, {
					scrollTo: {
						y: 0
					},
					ease: Expo.easeInOut
				});*/

			// Set navigation
			/*$pb.navigation
				.find('li:eq(' + num + ')')
				.addClass('active')
				.siblings('.active')
				.removeClass('active');*/

			// Find the new product
			var $new = $pb.slides[num],
				$old = $pb.current;

			// Hide the old image
			if( !skipExit ){

				TweenLite
					.to($old.image, .3, {
						opacity: 0,
						scale: 1.05,
						ease: Cubic.easeIn,
						force3D: true
					});

			}

			// Show the new product
			TweenLite
				.set($new.root, {
					visibility: 'visible',
					zIndex: 2
				});

			TweenLite
				.fromTo($pb.wrapper, .3, {
					height: $pb.wrapper.height()
				},{
					height: $new.root.height(),
					ease: Cubic.easeInOut,
					force3D: true,
					delay: skipExit ? 0 : .3,
					clearProps: 'all',
					onComplete: function(){

						if( skipExit ){

							TweenLite
								.set($old.root, {
									visibility: 'hidden',
									position: 'absolute'
								});

							// Not busy
							pb.busy = false;

						}

						TweenLite
							.set($new.root, {
								position: 'relative',
								clearProps: 'zIndex'
							});

					}
				});

			// Animate the new image
			TweenLite
				.fromTo($new.image, .6, {
					scale: .9,
					opacity: 0
				},{
					scale: 1,
					opacity: 1,
					ease: Elastic.easeOut.config(1, .75),
					delay: .3,
					force3D: true
				});

			// Hide the old copy
			if( !skipExit ){

				TweenLite
					.to($old.copy, .3, {
						opacity: 0,
						x: dir ? dir == 'left' ? -30 : 30 : 0,
						ease: Back.easeIn,
						force3D: true,
						delay: .05,
						clearProps: 'all',
						onComplete: function(){

							TweenLite
								.set($old.root, {
									visibility: 'hidden',
									position: 'absolute'
								});

							// Not busy
							pb.busy = false;

						}
					});

			}

			// Show the new copy
			var x = dir ? dir == 'left' ? 30 : -30 : 0;

			$new.copy
				.children()
				.each(function(i){

					TweenLite
						.fromTo(this, .6 + ( .02 * i ), {
							x: x,
							y: dir ? 0 : 30,
							opacity: 0
						},{
							x: 0,
							y: 0,
							opacity: 1,
							force3D: true,
							delay: .35 + ( i * .05 ),
							clearProps: 'all',
							ease: Expo.easeOut
						});

				});

			// Update stored variables
			$pb.current = $new;
			pb.current = num;

		},
		touch: function(e){

			var width = site.width,
				touch = e.originalEvent.touches[0],
				startX = touch.clientX,
				startY = touch.clientY,
				endX = 0,
				active = false,
				vertical = false;

			if( pb.busy ) return false;

			$core.win
				.one('touchend', function(e){

					$core.win.off('.pb');

				})
				.on('touchmove.pb', function(e){

					var thisTouch = e.originalEvent.touches[0],
						x = thisTouch.clientX,
						y = thisTouch.clientY;

					// Move it
					TweenLite
						.set($pb.wrapper, {
							x: x - startX
						});

					if( active ){

						e.preventDefault();

					}else{

						if( Math.abs( y - startY ) > 4 && !active && !vertical ){

							vertical = true;

							TweenLite
								.set($pb.wrapper, {
									x: 0
								});

							$core.win.off('.pb');

						}else if( Math.abs( x - startX ) > 4 && !active && !vertical ){

							active = true;
							vertical = false;

							$core.win
								.one('touchend', function(e){

									var x = e.originalEvent.changedTouches[0].clientX,
										distance = x - startX,
										next = distance < 0,
										newC = next ? pb.current + 1 : pb.current - 1;

									if( newC > pb.total - 1 || newC < 0 )
										newC = false;

									if( Math.abs( distance ) > site.width / 6 && newC !== false ){

										TweenLite
											.to($pb.wrapper, .2, {
												x: next ? 0 - width : width,
												ease: Cubic.easeOut
											});

										pb.goTo(newC, next ? 'left' : 'right', true);

									}else{

										TweenLite
											.to($pb.wrapper, .2, {
												x: 0,
												ease: Expo.easeOut
											});

									}

								});

						}

					}

				});

		}
	};

	pb.init();

}());